import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import routerReducer from './router'
import reducers from './modules'

const rootReducer = combineReducers({
  router: routerReducer,
  form: formReducer,
  ...reducers
})

export default rootReducer
